export const pause = (ms: number) => new Promise(r => setTimeout(r, ms))

export function logEvent(n:string):void {
  console.log('@event:', n);
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({'event' : 'webar', 'event_name' : n});
}

export const getElem = (name: string) => {
  let elem = document.getElementById(`${name}`);
  if(!elem) throw new Error(`Missing HTML element ${name}`);
  return elem;
}

// This "removes" the animation first, then "resets" it, thus triggering the animation again
export const animateElement = async (element: HTMLElement, forward: boolean, timeDelay = 0) => {
  element.style.animation = 'none';
  element.offsetHeight;
  await pause(timeDelay);
  element.style.animation = '';
  element.style.animationDirection = forward ? "normal" : "reverse";
}

// Get actual viewport size with small-viewport units for better mobile support
export const getViewportSize = () => {
    // Use SVH/SVW if available for better mobile support
    const width = window.innerWidth;
    const height = window.innerHeight;
    return { width, height };
};

const lionLogo = getElem("lionLogo");
export const toggleBottomLogo = (show: boolean, forceVal?: string) => {
  if(forceVal) 
    lionLogo.style.bottom = forceVal;
  else
    lionLogo.style.bottom = show ? "25px" : "-150px"
}

const background = {
  bg: getElem("background-withText"),
  bgText: getElem("bg-text"),
}

export const toggleBgWithText = async (show: boolean) => {
  background.bg.style.opacity = show ? "1" : "0"
  if(show) background.bg.style.display = 'block';
  await pause(500);
  if(!show) background.bg.style.display = 'none';
}
toggleBgWithText(false);

export const bgTextMove = (val: number) => {
  background.bgText.style.left = `${val}`;
}
